// extracted by mini-css-extract-plugin
module.exports = {"wrap":"IconsProducts_wrap__2kWPo","iconProduct":"IconsProducts_iconProduct__XULUI"};